import * as React from 'react'
import Checkbox from '@mui/material/Checkbox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import {useState} from 'react'
import {Autocomplete, FormControl} from '@mui/material'
import {CustomInputLable} from './SelectField'
import * as form from '../modules/insurance/healthInsurance/redux/healthInsuranceRedux'
import * as auto from '../modules/insurance/AutoInsurance/redux/autoRedux'
import * as moto from '../modules/insurance/MotoInsurance/redux/motoRedux'
import * as user from '../modules/insurance/healthInsurance/redux/userRedux'
import * as filter from '../redux-commons/FilterRedux/filterRedux'
import {useDispatch} from 'react-redux'
import { AutoCompleteInput } from './AutoCompleteMultiple'

type Props = {
  options: any
  label: string
  defaultValue: any
  id?: string
  formName?: string
  tabName?: string
  required?: boolean
  handleValueSelected?: (value: any) => void
  validateField?: boolean
  autoCompleteReadOnly?: boolean
}

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
const checkedIcon = <CheckBoxIcon fontSize='small' />

export const AutoCompleteMultiple: React.FC<Props> = ({
  options,
  label,
  defaultValue,
  id,
  required,
  handleValueSelected,
  validateField,
  autoCompleteReadOnly,
  formName,
  tabName,
}) => {
  const [value, setValue] = useState<any>([])

  const dispatch = useDispatch()

  const saveDataToRedux = (value: string) => {
    if (formName && formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        field: id ? id : '',
        value: value ? value : '',
        filterForm: formName,
      }
      dispatch(filter.actions.updateFilterInfo(data))
    } else if (formName && formName.toLowerCase().includes('formperson')) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
      }
      dispatch(form.actions.addProductInfo(data))
    } else if (formName && formName.toLowerCase().includes('auto')) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
      }
      dispatch(auto.actions.addAutoInfos(data))
    } else if (formName && formName.toLowerCase().includes('moto')) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
      }
      dispatch(moto.actions.addMotoInfos(data))
    }
    // else if (
    //   formName &&
    //   (formName.toLowerCase().includes('product') ||
    //     formName.toLowerCase().includes('cargo') ||
    //     formName.toLowerCase().includes('marine') ||
    //     formName.toLowerCase().includes('property') ||
    //     formName.toLowerCase().includes('technical'))
    // ) {
    //   let data = {
    //     key: id ? id : '',
    //     value: value ? value : '',
    //     tab: tabName ? tabName : '',
    //     form: formName ? formName : '',
    //   }
    //   dispatch(product.actions.addProductInfos(data))
    // }
  }

  const handleChangeValue = (e: any, value: any) => {
    setValue(value)
    if (handleValueSelected) handleValueSelected(value)
    if (formName) {
      saveDataToRedux(value.length > 0 ? value.map((o: any) => o.value).toString() : null)
    }
  }

  // const handleChangeValue = (e: any, value: any) => {
  //   setValue(value)
  //   if (handleValueSelected) handleValueSelected(value)
  // }

  React.useEffect(() => {
    if (typeof defaultValue === 'string' && defaultValue) {
      let selected = defaultValue.split(',').map((o) => options.find((c: any) => c.value == o))
      if (selected) setValue(selected)
      else setValue([])
    } else {
      setValue(defaultValue ? defaultValue : [])
    }
  }, [defaultValue, options])

  return (
    <div className='field-wrapper' style={{width: '100%'}}>
      <FormControl error={validateField} sx={{width: '100%'}}>
        <CustomInputLable id={label} htmlFor={id} aria-label='test'>
          {label}
          {required && <span className='input-require'> *</span>}
        </CustomInputLable>
        <Autocomplete
          multiple
          value={value}
          id={id}
          options={options}
          disableCloseOnSelect
          getOptionLabel={(option: any) => option?.name || option?.label}
          getOptionDisabled={(option: any) => option.disable}
          readOnly={autoCompleteReadOnly}
          renderOption={(props, option, {selected}) => (
            <li {...props} key={option.value ? option.value : option.code}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{marginRight: 8}}
                checked={
                  value.find((o: any) =>
                    option.value ? o.value == option.value : o.code == option.code
                  ) != null
                }
              />
              {option?.name ? option?.name : option?.label}
            </li>
          )}
          onChange={(e, value) => handleChangeValue(e, value)}
          renderInput={(params) => (
            <AutoCompleteInput {...params} label={label} error={validateField} />
          )}
        />
      </FormControl>
    </div>
  )
}
